import * as React from 'react';
import { DefaultButton, IButtonProps } from '@fluentui/react/lib/Button';
import { IButtonStyles } from '@fluentui/react';
import { Spinner, SpinnerSize } from '@fluentui/react';

export const SmartActionButtonStyles: IButtonStyles = {
  root: {
    backgroundColor: '#f3f3f3',
    borderColor: '#d0d0d0',
    color: '#333333',
    padding: '10px 18px',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 6,
    transition: 'all 0.3s ease',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    userSelect: 'none',
    selectors: {
      '::after': {
        border: 'none !important',
        outline: 'none !important',
        content: 'none !important',
      },
    },
  },
  rootHovered: {
    backgroundColor: '#e0e0e0',
    borderColor: '#c0c0c0',
    color: '#1a1a1a',
    boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
    transform: 'translateY(-2px)',
  },
  rootPressed: {
    backgroundColor: '#d6d6d6',
    borderColor: '#a0a0a0',
    color: '#000000',
    boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.2)',
    transform: 'translateY(0)',
  },
  icon: {
    color: '#333333',
    transition: 'transform 0.3s ease',
  },
};

interface SmartActionButtonProps extends Pick<IButtonProps, 'onClick' | 'text' | 'disabled' | 'className'> {
  icon?: JSX.Element;
  loading?: boolean;
}

const SmartActionButton: React.FC<SmartActionButtonProps> = ({ icon, loading, ...props }) => {
  return (
    <DefaultButton
      {...props}
      tabIndex={-1}
      styles={SmartActionButtonStyles}
      onRenderIcon={
        icon
          ? () => (
              <span
                style={{
                  width: 26,
                  height: 26,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: props.disabled ? 0.5 : 1,
                }}
              >
                {loading ? (
                  <Spinner
                    size={SpinnerSize.medium}
                    styles={{
                      circle: {
                        borderWidth: 3,
                      },
                    }}
                  />
                ) : (
                  icon
                )}
              </span>
            )
          : undefined
      }
    />
  );
};

export default SmartActionButton;
